import { NgModule } from '@angular/core';
import { ContactInfoFormModule } from 'app/components/contact-info/contact-info.module';
import { SharedModule } from 'app/shared/shared.module';
import { QuickCreateCustomerComponent } from './quick-create-customer.component';
import { CustomFieldFormModule } from 'app/components/custom-field-form/custom-field-form.module';

@NgModule({
    declarations: [
        QuickCreateCustomerComponent,
    ],
    imports: [
        SharedModule,
        ContactInfoFormModule,
        CustomFieldFormModule
    ],
    exports: [
        QuickCreateCustomerComponent
    ]
})
export class QuickCreateCustomerModule { }
